import { TvTivioProvider } from '@tivio/sdk-react'
import React, { PropsWithChildren, useMemo } from 'react'

import { ENV } from '../../env'
import { tivioConfig } from '../../static/tivioConfig'
import { useCustomer } from '../hooks/useCustomer'


/**
 * Using tivio config based on customer value in CustomerProvider
 */
const AppTivioProvider: React.FC<PropsWithChildren> = (props) => {
    const customer = useCustomer()
    const config = useMemo(
        () => {
            return tivioConfig[customer]?.[ENV.PLATFORM]
        },
        [ customer ],
    )

    if (!config) {
        throw new Error(`Tv config for customer ${customer} does not exist`)
    }

    return (
        <TvTivioProvider conf={config}>
            {props.children}
        </TvTivioProvider>
    )
}

export {
    AppTivioProvider,
}
